import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, formatApiError } from "@/admin/api";
import PageHeader from "@/admin/components/PageHeader";
import { UploadForm } from "@/admin/components/PortfolioUploadForm";
import { PortfolioRow } from "@/admin/components/PortfolioRow";

export default function PortfolioAdmin() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await adminApi.get("/portfolio");
      setItems(data.items || []);
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const replace = (item) => setItems((list) => list.map((it) => (it.id === item.id ? item : it)));
  const homeCount = items.filter((it) => it.show_on_home !== false).length;

  return (
    <div data-testid="admin-portfolio-page">
      <PageHeader
        eyebrow="Showcase"
        title="Portfolio"
        description="Upload drawing samples (PDF). Visitors can view them on the site but cannot download them."
      />
      <div className="p-8 space-y-8">
        <UploadForm onUploaded={(item) => setItems((l) => [...l, item])} />
        <div className="bg-white border border-zinc-200 overflow-x-auto">
          <div className="p-4 border-b border-zinc-200 flex items-center justify-between text-xs font-mono text-zinc-600">
            <span data-testid="portfolio-admin-total">{items.length} samples</span>
            <span data-testid="portfolio-admin-home-count">{homeCount} on home slider</span>
          </div>
          <table className="w-full text-sm">
            <thead className="bg-zinc-50 text-left">
              <tr className="text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500">
                <th className="p-3">Preview</th>
                <th className="p-3">Title</th>
                <th className="p-3">Service</th>
                <th className="p-3">State</th>
                <th className="p-3">Year</th>
                <th className="p-3">Home slider</th>
                <th className="p-3" />
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-200">
              {items.map((it) => <PortfolioRow key={it.id} item={it} onSaved={replace} />)}
              {!loading && !items.length && (
                <tr><td colSpan={7} className="p-10 text-center text-zinc-500">No samples yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
